import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

const i18nInitPromise = i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: false,
    react: {
        useSuspense: false
    },

    // Escrito no mesmo formato da pasta em public/locales, já que é daqui que o backend
    // HTTP monta a URL (/locales/{lng}/translation.json). O i18next normaliza 'pt-br' para
    // 'pt-BR' sozinho, então o minúsculo também funcionava; manter igual à pasta evita ter
    // que confiar nessa normalização.
    lng: 'pt-BR', // Idioma inicial usado.
    fallbackLng: 'pt-BR', // o idioma que será usado caso algumas traduções não sejam definidas.

    // Sem isto o i18next expande 'pt-BR' em ['pt-BR', 'pt'] e tenta carregar as duas, o que
    // gera um 404 em /locales/pt/translation.json (pasta que não existe). 'currentOnly'
    // carrega só o idioma pedido, que é o único que temos traduzido.
    load: 'currentOnly',

    backend: {
      // Caminho explícito para não depender do padrão da biblioteca.
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
export { i18nInitPromise };
